/**
 * @author Adrian Judd <AngularJS@AdrianJudd.co.uk>
 */
angular.module('pitch.media')
    .controller('PitchDownloadModalCtrl', ['$scope', function($scope, $rootScope) {
        "use strict";

        $scope.download = function(format) {
            $scope.$close(true, {
                format: format
            });
            deregisterlistener();
            deregisterFlaclistener();
        };

        var deregisterlistener = $scope.$on('MEDIA_WAV', function(event, data){
            $scope.filteredSubjects = data.filteredSubjects;
        });

        var deregisterFlaclistener = $scope.$on('MEDIA_FLAC', function(event, data) {
            $scope.flacfilteredSubjects = data.filteredSubjects;
        });

    }]);



// WEBPACK FOOTER //
// ./src/MediaClientBundle/Resources/js/angular/controllers/PitchDownloadModalCtrl.js